import React, { useEffect, useState } from "react";

export const Gauge = ({ value = 78, size = 190 }) => {
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    const id = setInterval(() => {
      const delta = (Math.random() - 0.5) * 4;
      setDisplayValue(Math.max(70, Math.min(86, Math.round(value + delta))));
    }, 2800);
    return () => clearInterval(id);
  }, [value]);

  // Map value 0-100 to angle -90 to +90
  const angle = (displayValue / 100) * 180 - 90;
  const w = size;
  const h = size * (105 / 190);
  const cx = w / 2;
  const cy = h - 6;
  const r = w / 2 - 14;

  // Polar to cartesian
  const polar = (deg, radius = r) => ({
    x: cx + radius * Math.cos((deg - 180) * (Math.PI / 180)),
    y: cy + radius * Math.sin((deg - 180) * (Math.PI / 180)),
  });

  // Build dashed semicircle arc
  const arcStart = polar(0); // left
  const arcEnd = polar(180); // right
  const arcPath = `M ${arcStart.x} ${arcStart.y} A ${r} ${r} 0 0 1 ${arcEnd.x} ${arcEnd.y}`;

  return (
    <div className="relative" style={{ width: w, height: h + 24 }} data-testid="risk-gauge">
      <svg width={w} height={h + 6} viewBox={`0 0 ${w} ${h + 6}`}>
        <defs>
          <linearGradient id="gauge-fill" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#27ae60" />
            <stop offset="55%" stopColor="#f39c12" />
            <stop offset="100%" stopColor="#E24B4A" />
          </linearGradient>
        </defs>
        {/* Track */}
        <path d={arcPath} stroke="#181c2a" strokeWidth="10" fill="none" strokeLinecap="butt" />
        {/* Fill (only up to value) */}
        <path
          d={arcPath}
          stroke="url(#gauge-fill)"
          strokeWidth="10"
          fill="none"
          strokeLinecap="butt"
          strokeDasharray={`${(displayValue / 100) * (Math.PI * r)} ${Math.PI * r}`}
          style={{ transition: "stroke-dasharray 1.2s cubic-bezier(0.4,0,0.2,1)" }}
        />
        {/* Tick marks */}
        {[0, 25, 50, 75, 100].map((t) => {
          const a = (t / 100) * 180;
          const inner = polar(a, r - 8);
          const outer = polar(a, r + 4);
          return (
            <line
              key={t}
              x1={inner.x}
              y1={inner.y}
              x2={outer.x}
              y2={outer.y}
              stroke="#636880"
              strokeWidth="1"
            />
          );
        })}
        {/* Needle */}
        <g
          className="gauge-needle"
          style={{
            transform: `rotate(${angle}deg)`,
            transformOrigin: `${cx}px ${cy}px`,
          }}
        >
          <line x1={cx} y1={cy} x2={cx} y2={cy - r + 6} stroke="#f0f2f8" strokeWidth="2" strokeLinecap="round" />
          <circle cx={cx} cy={cy} r="5" fill="#111420" stroke="#f0f2f8" strokeWidth="1.5" />
        </g>
      </svg>
      <div
        className="absolute left-0 right-0 text-center"
        style={{
          top: h - 38,
          fontFamily: "DM Mono, monospace",
          fontSize: 36,
          color: "#f3b14a",
          fontWeight: 500,
          lineHeight: 1,
        }}
        data-testid="gauge-value"
      >
        {displayValue}
      </div>
    </div>
  );
};
